import * as React from 'react'
import { cn } from '#app/utils/misc.tsx'

type PartHeadProps = {
	/** Section number, e.g. "03". Rendered as "§ 03" in gold. */
	num: string
	/** Kicker label, e.g. "The Results". */
	kicker: string
	/** The headline content — rendered inside an `<h2>`. */
	children: React.ReactNode
	className?: string
}

/**
 * Case-study section header — § number + kicker meta strip above an h2.
 * Pairs with the long-form article shell.
 */
export function PartHead({ num, kicker, children, className }: PartHeadProps) {
	return (
		<header className={cn('mb-8', className)}>
			<div className="flex flex-col gap-3">
				<div className="flex items-center gap-3 font-mono text-[11px] tracking-[0.18em] text-muted-foreground uppercase">
					<span className="font-medium text-gold">§ {num}</span>
					<span className="inline-block h-1 w-1 rounded-full bg-gold" />
					<span>{kicker}</span>
				</div>
				<h2 className="text-h2">{children}</h2>
			</div>
		</header>
	)
}
